<template>
  <a-tooltip placement="top">
    <template #title>
      <span>刷新</span>
    </template>
    <a-icon type="redo" class="settings-icon" />
  </a-tooltip>
</template>
<script>
export default {
  name: "RedoSetting",
  components: {},
  computed: {},
  props: {
    asd: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    // this.getCategory();
  },
  data() {
    return {
      userInfo: {
        name: "admin",
      },
      isMobile: false,
    };
  },
  methods: {},
};
</script>
